import { gearsLoader } from "@made-people/gears-remix";
import {
  withGlobalStory,
  WithGlobalStoryProps,
} from "../../utils/with-global-story";
import { getStoryFromGlobalStoryblokStoriesBySlug } from "../../utils/global-story-functions";
import { FooterProps } from "@made-people/blueprint-footer";
import { useRouteLoaderData } from "@remix-run/react";
import { SbBlokData } from "@storyblok/js";
import { NewsletterSignupProps } from "@made-people/blueprint-newsletter-signup";
import { TrustpilotWidget } from "../features/trustpilot/components/trustpilot-widget";
import { LogoList } from "./LogoList";

const Component = withGlobalStory(
  {
    lookupType: "slug",
    slug: "shared-content/footer/global-footer",
  },
  (story) =>
    ({
      ...story,
      template: "template2",
    }) satisfies FooterProps,
);

export const Footer = (props: WithGlobalStoryProps) => {
  const loaderData = useRouteLoaderData<typeof gearsLoader>(
    "project-router-wildcard",
  );

  if (!loaderData) return null;

  const {
    pageResponse: { page },
  } = loaderData;

  const isCheckout =
    page.pageType === "checkoutFinalize" ||
    page.pageType === "checkoutReceipt" ||
    page.pageType === "checkoutIndex";

  if (isCheckout) return null;

  // Storyblok partner-logos structure: { logos: [{ logos: SbBlokData[] }] }
  const partnerLogosStory = getStoryFromGlobalStoryblokStoriesBySlug(
    "shared-content/partner-logos/partner-logos",
    props.globalStoryblokStories,
  ) as { logos?: Array<{ logos?: SbBlokData[] }> } | undefined;

  const logos = partnerLogosStory?.logos?.[0]?.logos ?? [];
  const awardLogos = partnerLogosStory?.logos?.[1]?.logos ?? [];

  const newsletterConfig: NewsletterSignupProps = {
    template: "template4",
    heading: {
      heading: "Newsletter_Signup_Heading",
    },
    form: {
      inputField: {
        placeholder: "Newsletter_Email_Placeholder",
      },
      phoneNumberField: {
        placeholder: "Newsletter_PhoneNumber_Placeholder",
      },
      submitButton: {
        buttonLabel: "Newsletter_Subscribe_Button",
      },
      subscribeAttributes: {
        optinMethod: "footer",
      },
    },
  };

  return (
    <div className="bg-surface-1">
      <div className="mx-auto max-w-[1380px] pt-8 lg:-mb-12 lg:grid lg:grid-cols-4">
        <div
          className={`flex justify-center ${
            awardLogos && awardLogos.length > 0
              ? "lg:col-span-3"
              : "lg:col-span-4"
          }`}
        >
          <TrustpilotWidget />
        </div>
        <div className="hidden lg:col-span-1 lg:flex lg:justify-center [&_*]:lg:!justify-center [&_img]:!h-12">
          <LogoList
            bloks={
              awardLogos && awardLogos?.length > 0
                ? [{ ...partnerLogosStory?.logos?.[1], logos: awardLogos }]
                : undefined
            }
          />
        </div>
      </div>
      <Component
        {...props}
        additionalProps={{
          newsletter: {
            isEnabled: true,
            settings: newsletterConfig,
          },
          partnerLogos: {
            template: "template1",
            logos,
          },
        }}
      />
      {awardLogos && awardLogos.length > 0 && (
        <div className="flex justify-center pb-24 lg:hidden [&_*]:!justify-center [&_img]:!h-12">
          <LogoList
            bloks={[{ ...partnerLogosStory?.logos?.[1], logos: awardLogos }]}
          />
        </div>
      )}
    </div>
  );
};
